import React from "react";
import "./howItWorks.scss";

// Imagens:
import ImgHowItWorks from "../../../../assets/homeImgs/how-it-works-desktop.png"
import { useTranslation } from "react-i18next";

const HowItWorks = () => {
    const {t} = useTranslation()

    return (
        <div className="container-how-it-works">
            <div className="title-how-it-works">
                <h1>{t("home.how_it_works.title")}</h1>
            </div>
            <div data-aos="flip-down" className="image-how-it-works">
            
                <img src={ImgHowItWorks} alt="" />
            </div>

        </div>
    )
}
export default HowItWorks;